var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDocumentScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6666 0.666672H6.99992C3.33325 0.666672 0.366586 3.66667 0.366586 7.33334L0.333252 60.6667C0.333252 64.3334 3.29992 67.3334 6.96658 67.3334H46.9999C50.6666 67.3334 53.6666 64.3334 53.6666 60.6667V20.6667L33.6666 0.666672ZM40.3332 54H13.6666V47.3333H40.3332V54ZM40.3332 40.6667H13.6666V34H40.3332V40.6667ZM30.3332 24V5.66667L48.6666 24H30.3332Z",
    fill: "#E1E1E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocumentScanIcon);
export default __webpack_public_path__ + "static/media/no-document-scan-icon.013d12c1b340326ce795388147596a9d.svg";
export { ForwardRef as ReactComponent };